const LaserBackground = () => {
  return (
    <div className="laser-container">
      <div className="laser-beam magenta"></div>
      <div className="laser-beam cyan"></div>
      <div className="laser-beam purple"></div>
      <div className="laser-beam magenta"></div>
      <div className="laser-beam cyan"></div>
      <div className="laser-beam purple"></div>
      <div className="laser-beam magenta"></div>
      <div className="laser-beam cyan"></div>
      <div className="laser-beam purple"></div>
    </div>
  );
};

export default LaserBackground;
